<template>
  <div class="end-overlay">
    <div class="end-card">
      <p v-if="win">C'est gagné pour aujourd'hui !</p>
      <p v-else>Ce sera pour demain…</p>
      <div class="solution-row">
        <span
          v-for="(ch, i) in solution"
          :key="i"
          class="solution-cell"
        >
          {{ ch }}
        </span>
      </div>
      <div class="buttons">
        <button @click="$emit('share')">PARTAGER</button>
        <button @click="$router.push('/')">ACCUEIL</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EndScreen",
  props: {
    win: { type: Boolean, default: false },
    solution: { type: String, required: true }
  }
};
</script>

<style scoped>
.end-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.end-card {
  background: #ffffff;
  color: #154153;
  padding: 20px 24px;
  border-radius: 16px;
  box-shadow: 0 10px 0 rgba(0, 0, 0, 0.35);
  text-align: center;
}

.solution-row {
  margin: 16px 0 8px;
}

.solution-cell {
  display: inline-block;
  padding: 4px 6px;
  margin: 1px;
  background: #d63f35;
  color: #ffffff;
  font-weight: 800;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
}

.buttons button {
  background: #0e5569;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
  font-weight: 700;
}
</style>
